import { SET_SUMMARIES } from 'actionTypes';

export function setSummaries(summaries) {
  return {
    type: SET_SUMMARIES,
    summaries,
  };
}



// WEBPACK FOOTER //
// ./src/actions/summariesActions.js